const API_BASE_URL = `${process.env.PUBLIC_URL}`;

export default (resource) => {
  return fetch(`${API_BASE_URL}/${resource}`, {
    credentials: 'include',
  });
};



// WEBPACK FOOTER //
// ./src/core/fetchResource.js